module.exports = __webpack_public_path__ + "img/category-13.149c7ddb.svg";